export default "__VITE_ASSET__CTVIXRGp__"